// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Textarea_textarea__K_MJR"};